import { render, staticRenderFns } from "./script-type-selector.vue?vue&type=template&id=3cfaebe6&scoped=true&"
import script from "./script-type-selector.vue?vue&type=script&lang=js&"
export * from "./script-type-selector.vue?vue&type=script&lang=js&"
import style0 from "./script-type-selector.vue?vue&type=style&index=0&id=3cfaebe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfaebe6",
  null
  
)

export default component.exports